import { CHANGE_VEHICLE, CHANGE_VEHICLE_EMPTY, CHANGE_VEHICLE_ERROR, CHANGE_VEHICLE_SUCCESS } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ChangeVehicle = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_VEHICLE:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CHANGE_VEHICLE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CHANGE_VEHICLE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CHANGE_VEHICLE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ChangeVehicle;
